import { Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import { useNotify } from '../../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../../hooks/useSwaggerClient';
import PriceItemTable from '../../../../components/PriceItemTable';

const ChainPriceItemEditForm = ({ chainId }) => {
    const { notifySuccess, notifyError } = useNotify();
    const [chain, loading, error, setChain] = useSwaggerClient('chains', 'getChainById', {
        chainId
    });
    const chainPriceItemFlag = true;

    const formSaveDisabled = chain?.price_items
        ? chain?.price_items.filter(e => !e.name).length > 0
        : false;

    if (loading) {
        return <CircularProgress />;
    }
    return (
        <Grid container item xs={12}>
            {!error ? (
                <Grid container item xs={12} spacing={2}>
                    <PriceItemTable
                        items={chain?.price_items || []}
                        setItems={items => {
                            setChain(c => {
                                return {
                                    ...c,
                                    price_items: items.map(item => ({
                                        ...item,
                                        net_usd: parseFloat(item.net_usd),
                                        net_percentage: parseFloat(item.net_percentage)
                                    }))
                                };
                            });
                        }}
                        chainPriceItemFlag={chainPriceItemFlag}
                    />
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={formSaveDisabled}
                            onClick={() => {
                                doSwaggerCall('chains', 'updateChain', {
                                    chainId,
                                    chain
                                })
                                    .then(() => notifySuccess('Successfully updated price items'))
                                    .catch(err => notifyError(err.response.body.message));
                            }}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <h4>Could not load price items</h4>
            )}
        </Grid>
    );
};

export default ChainPriceItemEditForm;
